import React, { type FunctionComponent } from 'react'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { ConnectConfiguration } from 'domains/connect/components/ConnectConfiguration'
import { ConnectFulfillmentSimulator } from 'domains/connect/components/fulfillment-simulator/ConnectFulfillmentSimulator'
import { ConnectCallbackTesting } from 'domains/connect/components/ConnectCallbackTesting'

export const ConnectSection: FunctionComponent = () => (
  <DashSwitch>
    <DashRoute route="connect-configuration" component={ConnectConfiguration} />
    <DashRoute route="connect-fulfillment-simulator" component={ConnectFulfillmentSimulator} />
    <DashRoute route="connect-callback-testing" component={ConnectCallbackTesting} />
  </DashSwitch>
)
